module.exports = __webpack_public_path__ + "media/images/candidates-d6e28277817aa16962f778275421d569.png";